import axios from 'axios';
import { baseURL, refreshToken } from './refresh-token';

export const publicRest = axios.create({ baseURL });

export const rest = axios.create({ baseURL });

rest.interceptors.request.use(async (config) => {
  const accessToken = localStorage.getItem('access_token');
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${accessToken}`,
  };
  return config;
});

rest.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    if (error?.response?.status === 401 && !config?.sent) {
      const auth = await refreshToken();
      return rest.request({
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${auth.access_token}`,
        },
      });
    }
    return Promise.reject(error);
  },
);
